export const PROJECT_CODE_LENGTH = 6;
export const fillZeroToProjectCode = (value: number | null): string | null => {
  if (value === null) {
    return value;
  }
  return value.toString().padStart(PROJECT_CODE_LENGTH, '0');
};
